import React from "react";
import { Link } from "react-router-dom";
import fr from "@/locales/fr.json";

/**
 * Thank you page — French only, mounted at /thank_you.
 * "Back home" navigates to /.
 */
export default function ThankYou() {
  const t = (k) => {
    const parts = k.split(".");
    let cur = fr;
    for (const p of parts) cur = cur?.[p];
    return cur ?? k;
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-slate-900 text-white border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center gap-3">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-white text-slate-900 font-black tracking-tighter">E</span>
          <span className="font-black tracking-[0.18em] text-[15px]">{t("brand.name")}</span>
        </div>
      </header>
      <main className="flex-1 flex items-center">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16 lg:py-24 text-center">
          <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-emerald-100 text-emerald-700 text-2xl font-bold border border-emerald-200 mb-6">
            ✓
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900" data-testid="thank-you-title">
            {t("thank_you.title")}
          </h1>
          <p className="text-lg text-slate-700 mt-4">{t("thank_you.subtitle")}</p>
          <p className="text-base text-slate-600 mt-6 leading-relaxed">{t("thank_you.body")}</p>

          <div className="mt-10 text-left bg-white border border-slate-200 rounded-xl p-6">
            <h2 className="text-lg font-semibold text-slate-900">{t("thank_you.next_title")}</h2>
            <ul className="mt-4 space-y-2 text-slate-700 text-sm">
              <li className="flex gap-2"><span className="text-amber-600 font-bold">·</span>{t("thank_you.point_1")}</li>
              <li className="flex gap-2"><span className="text-amber-600 font-bold">·</span>{t("thank_you.point_2")}</li>
              <li className="flex gap-2"><span className="text-amber-600 font-bold">·</span>{t("thank_you.point_3")}</li>
            </ul>
          </div>

          <Link
            to="/"
            className="inline-block mt-10 bg-slate-900 hover:bg-slate-800 text-white font-semibold px-6 py-3 rounded-md text-sm"
            data-testid="thank-you-back-home"
          >
            {t("thank_you.back_home")}
          </Link>
        </div>
      </main>
      <footer className="bg-slate-950 text-slate-500 text-xs">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex justify-between">
          <span>{t("footer.copyright")}</span>
          <span>{t("footer.email")}</span>
        </div>
      </footer>
    </div>
  );
}
